import React, { useState } from "react";
import './feedback.css';
import { FiThumbsUp } from "react-icons/fi";
import { FiThumbsDown } from "react-icons/fi";
import { sendFeedback } from "../../functions/apiCalls/api";


export default function Feedback({ index, message, uuid, clientID, setMessages }) {

    const [feedback, setFeedback] = useState(null);
    const inputOpen = process.env.REACT_APP_CHAT_OPEN_INPUT !== 'false';

    const verificaResposta = (estado) => {
        setFeedback(estado);
        sendFeedback(estado, message[index].request, message[index].response, uuid, clientID);
        
        if(estado === 'negativo'){
            
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'event_click_deslike',
                click_id: 'button-negative'
            });

            if(inputOpen){
                const body = { origin: 'bot', response: "Lamentamos por isso. Digite sua dúvida em outras palavras e vamos te ajudar", options: [], error: true, desativaFeedbackPorMensagem: true };
                setMessages(message =>[...message, body])
            }

        }else{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'event_click_like',
                click_id: 'button-positive'
            });
        }

    };
    
    return (
        <div className={`feedback-container`}>
            <button id="positive-button" onClick={() => verificaResposta('positivo')} className={`feedback-button ${feedback === 'positivo' ? 'pressed' : feedback !== null && feedback !== 'positivo' ? 'non-pressed' : ''}`}><FiThumbsUp/></button>
            <button id="negative-button" onClick={() => verificaResposta('negativo')} className={`feedback-button ${feedback === 'negativo' ? 'pressed' : feedback !== null && feedback !== 'negativo' ? 'non-pressed' : ''}`}><FiThumbsDown /></button>
        </div>
    );
}